import { toggleScroll } from "PARENT/utilities/toggleScroll.js";

const header = document.getElementById("site-header");

const mobileMenuToggle = document.getElementById("mobile-menu-toggle");
const mobileMenu = document.getElementById("mobile-menu");

mobileMenuToggle?.addEventListener("click", () => {
    toggleMenu("mobile");
});

mobileMenu?.querySelectorAll("a").forEach((link) => {
    link.addEventListener("click", () => {
        closeMenus();
    });
});

/**
 * @param {string} menu Then menus name
 *
 * @return void
 */
function toggleMenu(menu) {
    if (header?.getAttribute("data-menu-active") === menu) {
        closeMenus();
    } else {
        openMenu(menu);
    }
}

/**
 * Opens the specified header menu
 *
 * @param {string} menu
 *
 * @return void
 */
function openMenu(menu) {
    header?.setAttribute("data-menu-active", menu);
    toggleScroll(false);
}

/**
 * Closes all the header menus
 *
 * @return void
 */
function closeMenus() {
    header?.removeAttribute("data-menu-active");
    toggleScroll(true);
}
